export default "__VITE_ASSET__u$$yrdsh__"